export const consumerReportServer = {
  baseURL: "https://consumer-report-v2-api.dailyvanity.com",
  reportBaseURL: 'https://consumer-report-v2-api.dailyvanity.com/customise',
  surveyURL: 'https://survey.dailyvanity.com',
}